import { observable, action } from "mobx";

export default class GuestPayment {
  /**
   * @property {number|null}
   */
  @observable guestPaymentId = null;

  /**
   * @property {number}
   */
  @observable tourId = null;

  /**
   * @property {number}
   */
  @observable otherProductId = null;

  constructor(data) {
    if (typeof data !== "undefined") {
      this.setData(data);
    }
  }

  @action setData(data) {
    const { guestPaymentId = null, tourId = null, otherProductId = null } = data;

    if (guestPaymentId !== null) {
      this.guestPaymentId = guestPaymentId;
    }

    if (tourId !== null) {
      this.tourId = tourId;
    }

    if (otherProductId !== null) {
      this.otherProductId = otherProductId;
    }
  }
}
